import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, AuthInviteResponseData, GetInviteSchema } from "schema"
import { z } from "zod"

type AuthInviteResponse = DataResponse<AuthInviteResponseData>

export const authInviteQuery = (inviteData: z.infer<typeof GetInviteSchema>) => {
  return queryOptions({
    queryKey: ["invite"],
    queryFn: async () => {
      const { data } = await axios.get<AuthInviteResponse>("/auth/invite", {
        params: inviteData,
      })

      return data.data
    },
    retry: 0,
  })
}
